"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookie = getCookie;
exports.getAccessToken = getAccessToken;
exports.hasAccessToken = hasAccessToken;
exports.setAccessToken = setAccessToken;
exports.expireAccessToken = expireAccessToken;
var configuration_1 = require("./configuration");
var ACCESS_TOKEN_COOKIE = "tp-b2b-access-token";
function getCookie(name) {
    var re = new RegExp("(?:(?:^|.*;\\s*)".concat(name, "\\s*\\=\\s*([^;]*).*$)|^.*$"), "g");
    var value = document.cookie.replace(re, "$1");
    return value;
}
function getAccessToken() {
    var cookieValue = getCookie(ACCESS_TOKEN_COOKIE);
    return cookieValue;
}
function hasAccessToken() {
    var cookieValue = getAccessToken();
    return cookieValue !== undefined && cookieValue.length > 0;
}
function setCookie(value, expires) {
    var cookie = [
        "".concat(ACCESS_TOKEN_COOKIE, "=").concat(value),
        "domain=".concat(configuration_1.configuration.cookieDomain),
        "path=/",
        "expires=".concat(expires.toUTCString()),
    ];
    if (configuration_1.configuration.environment !== "Development") {
        cookie.push("secure");
    }
    document.cookie = cookie.join(";");
}
function setAccessToken(value, expireInSeconds) {
    setCookie(value, new Date(new Date().getTime() + 1000 * expireInSeconds));
}
function expireAccessToken() {
    setCookie("", new Date(0));
}
//# sourceMappingURL=utils.js.map